import script from "./simplified.vue?vue&type=script&setup=true&lang=ts"
export * from "./simplified.vue?vue&type=script&setup=true&lang=ts"

import "./simplified.vue?vue&type=style&index=0&id=406c7e82&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-406c7e82"]])

export default __exports__